import React, { useRef, useState } from "react";
import tw, { styled, theme } from "twin.macro";
import profileImage from "../../../../../../assets/images/profile.png";
import useTranslator from "../../../../../../hook/common/useTranslator/useTranslator.hook";
import { Button } from "../../../../../atom/Button";
import Logout from "../../../../../atom/Icon/SVG/Logout";
import Image from "../../../../../atom/Image/Image.atom";
import OutsideAlerter from "../../../../../atom/OutsideAlerter/OutsideAlerter.atom";
import Popover from "../../../../../atom/Popover/Popover.atom";
import {
  ButtonLarge,
  ButtonSmall,
  Caption,
} from "../../../../../atom/Text/Text.atom";
import Tooltip from "../../../../../molecule/Tooltip/Tooltip.molecule";
import useProfile from "../../hook/useProfile.hook";

// #region STYLES

const ProfileContainer = styled.div(({ expanded }: { expanded?: boolean }) => [
  tw`[padding:14px_18px_18px] w-full flex gap-2.5 items-center border-t border-t-gray-50 cursor-pointer`,
  !expanded &&
    `
  #profile-meta{
    display: none
  }
  `,
]);
const ContentContainer = tw.div`max-w-[162px] w-full box-border flex items-center`;
const Content = tw.div`max-w-full box-border`;
const ContentName = tw.div`truncate flex`;
const ContentEmail = tw.div`truncate`;

const PopupContent = tw.div`px-3.5 py-2.5 gap-2.5 shadow-card flex flex-col rounded w-60 [height:105px] bg-white`;
const Divider = tw.hr`border-gray-100`;
const ButtonLogout = tw(Button.Text)`p-0 ml-3 w-fit`;

// #endregion

export default function ProfileSection({ expanded }: { expanded?: boolean }) {
  const tooltipRef = useRef(null);
  const translator = useTranslator();
  const [visible, setVisible] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const { handleClickLogout } = useProfile();

  return (
    <>
      <ProfileContainer
        ref={tooltipRef}
        onMouseEnter={() => {
          if (!expanded) setVisible(true);
        }}
        onMouseLeave={() => {
          if (!expanded) setVisible(false);
        }}
        onClick={() => setShowPopup(true)}
        expanded={expanded}
      >
        <Image
          onClick={() => setShowPopup(true)}
          src={profileImage}
          tw="w-10 h-10 aspect-square p-0.5 rounded-md cursor-pointer hover:(border border-primary-500)"
        />
        <ContentContainer>
          <Content id="profile-meta">
            <ContentName>
              <ButtonSmall tw="truncate">username</ButtonSmall>
            </ContentName>
            <ContentEmail>
              <Caption tw="truncate">userid</Caption>
            </ContentEmail>
          </Content>
        </ContentContainer>
        <Tooltip
          containerStyle={[tw`z-30`]}
          targetRef={tooltipRef}
          visible={visible}
          contentStyle={tw`p-2 flex`}
          variant="dark"
          placement="right"
          withPortal
        >
          <Caption tw="text-gray-50">Menu Profile</Caption>
        </Tooltip>
      </ProfileContainer>
      <Popover offset={[20, -60]} visible={showPopup} targetRef={tooltipRef}>
        <OutsideAlerter onClickAway={() => setShowPopup(false)}>
          <PopupContent>
            <ContentContainer>
              <Image
                onClick={() => void handleClickLogout()}
                src={profileImage}
                tw="w-10 h-10 aspect-square p-0.5 mr-2.5 rounded-md"
              />
              <Content>
                <ContentName>
                  <ButtonSmall tw="!flex truncate">username</ButtonSmall>
                </ContentName>
                <ContentEmail>
                  <Caption tw="!flex truncate">userid</Caption>
                </ContentEmail>
              </Content>
            </ContentContainer>
            <Divider />
            <ButtonLogout
              onClick={() => void handleClickLogout()}
              icon={<Logout fillPath={theme`colors.gray.500`} />}
            >
              <ButtonLarge tw="text-gray-500 !flex">
                {translator.translate("Logout")}
              </ButtonLarge>
            </ButtonLogout>
          </PopupContent>
        </OutsideAlerter>
      </Popover>
    </>
  );
}
